import { configureStore } from '@reduxjs/toolkit';
import singlePostReducer from '../features/post/SinglePost';
import filterPosts from '../features/postFilter/filterPosts';
import postReducer from '../features/posts/postSlice';
import tagPostReducer from '../features/tag/tagSlice';

export const store = configureStore({
  reducer: {
    posts: postReducer,
    postDetails: singlePostReducer,
    tagPosts: tagPostReducer,
    filterPosts: filterPosts,
  },
});
